import { AfterViewInit, Directive, ElementRef, EventEmitter, OnDestroy, Output } from '@angular/core';

/**
 * Output when this element is revealed in the viewport.
 */
@Directive({
  selector: '[fwLoadTrigger]',
})
export class FwLoadTrigger implements AfterViewInit, OnDestroy {
  @Output('fwLoadTrigger') visible = new EventEmitter<number>()

  private intersectionObserver: IntersectionObserver

  constructor(private elementRef: ElementRef) {}

  ngAfterViewInit(): void {
    this.intersectionObserver = new IntersectionObserver(entries => {
      const visibleEntry = entries.find(entry => entry.intersectionRatio > 0);
      if (visibleEntry) {
        this.visible.emit(visibleEntry.intersectionRatio);
      }
    });
    this.intersectionObserver.observe(this.elementRef.nativeElement);
  }

  ngOnDestroy(): void {
    if (this.intersectionObserver) {
      this.intersectionObserver.unobserve(this.elementRef.nativeElement);
      this.intersectionObserver.disconnect();
    }
  }
}
